<app-header></app-header>
<app-menu-bar></app-menu-bar>
<router-outlet></router-outlet>
<app-footer></app-footer>
